import { useIntl } from 'react-intl';
import StatusChip from '@rossum/components/status/StatusChip';
import {
  IconArrowNarrowRight,
  IconProgressCheck,
} from '@rossum/ui/icons/tabler';
import {
  ActivityRowLayout,
  PreviousValue,
  RowIcon,
  RowLabel,
  RowValue,
  toDisplayedStatus,
} from '../../core';

type StatusChangeRowProps = {
  previousValue: string | null;
  value: string | null;
};

const renderStatus = (status: string | null) => {
  const displayed = toDisplayedStatus(status);
  return displayed ? (
    <StatusChip status={displayed} />
  ) : (
    <RowValue value={null} />
  );
};

export const StatusChangeRow = ({
  previousValue,
  value,
}: StatusChangeRowProps) => {
  const intl = useIntl();
  return (
    <ActivityRowLayout
      dataCy="document-history-status-row"
      label={
        <RowLabel
          label={intl.formatMessage({
            id: 'features.documentHistory.field.status',
          })}
        />
      }
      labelIcon={<RowIcon icon={IconProgressCheck} />}
      icon={<RowIcon icon={IconArrowNarrowRight} />}
      value={renderStatus(value)}
      secondary={<PreviousValue>{renderStatus(previousValue)}</PreviousValue>}
    />
  );
};
